import { useEffect, useState, useRef } from 'react';
import { FlameFrame } from './KeralaDecor';
import specials from '../data/specials';
import site from '../data/site';
import './SpecialsCarousel.css';

const AUTO_INTERVAL = 6000;

export default function SpecialsCarousel() {
  const [active, setActive] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const touchStartX = useRef(null);

  useEffect(() => {
    if (isHovering) return;
    const id = setInterval(() => setActive((a) => (a + 1) % specials.length), AUTO_INTERVAL);
    return () => clearInterval(id);
  }, [isHovering]);

  const goPrev = () => setActive((a) => (a - 1 + specials.length) % specials.length);
  const goNext = () => setActive((a) => (a + 1) % specials.length);

  const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchStartX.current == null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (dx > 50) goPrev();
    else if (dx < -50) goNext();
    touchStartX.current = null;
  };

  return (
    <section
      className="sc"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div
        className="sc__pattern"
        aria-hidden="true"
        style={{ backgroundImage: 'url(/decor/leaf-pattern-tile.svg)' }}
      ></div>
      <div className="container">
        <div className="sc__head">
          <span className="eyebrow-script">This Weekend at H2 Fresh</span>
          <h2 className="sc__title">Weekend Specials</h2>
          <p className="sc__sub">Limited-time Kerala plates we cook in small batches. Call ahead, they go fast.</p>
        </div>

        <div
          className="sc__stage"
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <button className="sc__nav sc__nav--prev" onClick={goPrev} aria-label="Previous special">‹</button>

          <div className="sc__cards">
            {specials.map((s, i) => {
              const offset = i - active;
              const total = specials.length;
              const norm = ((offset % total) + total) % total;
              let stateClass = 'is-far';
              if (norm === 0) stateClass = 'is-active';
              else if (norm === 1) stateClass = 'is-next';
              else if (norm === total - 1) stateClass = 'is-prev';

              return (
                <div
                  key={s.id}
                  className={`sc__card ${stateClass}`}
                  style={{ '--flame-accent': s.accent }}
                  aria-hidden={stateClass !== 'is-active'}
                >
                  <FlameFrame accent={s.accent}>
                    <span className="sc__tag">{s.tag}</span>
                    <h3 className="sc__name">{s.title}</h3>
                    <p className="sc__day">{s.day}</p>
                    <p className="sc__desc">{s.description}</p>
                    <a href={`tel:${site.phones[0].tel}`} className="btn btn-gold sc__cta">
                      📞 Call to Order
                    </a>
                  </FlameFrame>
                </div>
              );
            })}
          </div>

          <button className="sc__nav sc__nav--next" onClick={goNext} aria-label="Next special">›</button>
        </div>

        <div className="sc__dots" role="tablist" aria-label="Specials">
          {specials.map((s, i) => (
            <button
              key={s.id}
              className={`sc__dot ${i === active ? 'is-active' : ''}`}
              onClick={() => setActive(i)}
              role="tab"
              aria-selected={i === active}
              aria-label={`Show ${s.title}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
